// Модуль для прорахунку висоти брови на андроїді
/* eslint-disable */
import { webviewCheck } from './webviewCheck'; // Імпортуємо функцію для перевірки типу веб-переглядача (WebView)
// function androidFixMono (idContainer) {
//     const androidContainer = document.querySelector("#" + idContainer);
//     // const androidHeader = document.querySelector("#headerContiner-white");

//     try{
//         if (webviewCheck() == 'android_webview') {

//             let s;
//             const androidBrov = Android.getDisplayCutoutTop();

//             if (window.devicePixelRatio > 1.0) {
//                 s = androidBrov / window.devicePixelRatio;
//             }
//             if (androidBrov != 0) {
//                 if(androidContainer){
//                     androidContainer.style.paddingTop =  s + 'px';
//                     // androidHeader.style.paddingTop = '40px';
//                 }
//             }
//         }
//     } catch(err) {
//         console.log(err);
//     }
// }
// export { androidFixMono }

function androidFixMono(idContainer) {
    const androidContainer = document.querySelector("#" + idContainer);

    try {
        if (webviewCheck() == 'android_webview') {

            const androidBrov = Android.getDisplayCutoutTop();
            const pixelRatio = window.devicePixelRatio || 1;
            const s = androidBrov / pixelRatio;

            if (androidBrov != 0) {
                if (androidContainer) {
                    androidContainer.style.paddingTop = s  + 'px';
                }
            }
        }
    } catch (err) {
        console.log(err);
    }
}
export { androidFixMono }